import React, { useEffect } from 'react'

import './styles.scss'
import {
  DraftsContainer,
  ThreadsContainer,
  ChannelsContainer,
  DirectMessagesContainer,
  SectionsContainer,
  SavedContainer,
  MentionsReactions,
} from './Containers'
import inchatAction from 'redux/inchat/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  DragDropContext,
} from 'react-beautiful-dnd'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setActiveChannel, setActiveUser } from 'redux/actions/tabs'


const SideMenuInChat = () => {
  const dispatch = useDispatch()
  const { tabs } = useSelector(state => state)
  const history = useHistory()

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getData = async () => {
    await dispatch(inchatAction.getMainMenu())
  }

  const onDragEnd = (result) => {
    const {
      destination,
      draggableId,
      source,
      type
    } = result
    const conversationId = draggableId
    const sourceId = source.droppableId
    const sourceIndex = source.index
    const destinationId = destination.droppableId
    const destinationIndex = destination.index
    if(type === 'CONVERSATIONS'){
      if (sourceId === destinationId) return
      dispatch(inchatAction.moveConversationSectionDirect({ conversationId, sourceId, sourceIndex, destinationId, destinationIndex }))
    }
    if(type === 'SECTIONS'){
      if(sourceIndex === destinationIndex) return
      dispatch(inchatAction.updateSectionOrder({
        indexOrigin: sourceIndex,
        indexDestination: destinationIndex
      }))
    }
  }

  const openCard = (idConversation) => {
    const {
      users,
    } = tabs
    const tabsContainSelectedUser = users.filter((u) => u === idConversation).length > 0
    if (users.length < 15 || tabsContainSelectedUser) {
      history.push(`${history.location.pathname}?user_id=${idConversation}`)
    }
  }

  const openPage = (page) => {
    history.push(`${history.location.pathname}?section=${page}`)
    dispatch(setActiveUser(''))
    dispatch(setActiveChannel(''))
  }

  return (
    <div className='inchat-menu animated fadeIn'>
      <ThreadsContainer openPage={openPage} />
      <MentionsReactions openPage={openPage} />
      <SavedContainer openPage={openPage} />
      <DraftsContainer openPage={openPage} />
      <ChannelsContainer openCard={openCard} />
      <DragDropContext onDragEnd={onDragEnd}>
        <DirectMessagesContainer openCard={openCard} />
        <SectionsContainer openCard={openCard} />
      </DragDropContext>
    </div>
  )
}

export default SideMenuInChat
